import { buildBinderListings } from '@monofe/di';
import dbInst from '../impl/instantiator.bind';

export default buildBinderListings([dbInst]);
